import React, { createContext } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider, createSelectorHook, createDispatchHook } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import reducer from './NotaFiscalDevedor.store';
import watchNotaFiscalDevedor from './NotaFiscalDevedor.saga';

export const NotaFiscalDevedorContext = createContext();
export const useNotaFiscalDevedorSelector = createSelectorHook(NotaFiscalDevedorContext);
export const useNotaFiscalDevedorDispatch = createDispatchHook(NotaFiscalDevedorContext);

export default function NotaFiscalDevedorProvider({ children }) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(reducer, applyMiddleware(sagaMiddleware));
  sagaMiddleware.run(watchNotaFiscalDevedor);

  return (
    <Provider context={NotaFiscalDevedorContext} store={store}>
      {children}
    </Provider>
  );
}
